const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          // palette values for light mode
          primary: {
            main: '#fff',
          },
          secondary: {
            main: '#F2F2F2',
          },
          tertiary: {
            main: '#006F56',
          },
          quaternary: {
            main: '#F2F2F2',
          },
          octonary: {
            main: '#F2F2F2',
          },
          nonary: {
            main: '#FFFFFF',
          },
          denary: {
            main: '#FFFFFF',
          },
          service: {
            main: '#FFFFFF',
          },
          borderSelect: {
            main: ' #041370',
            border: '#00DD9E',
            borderFocus: '#E0E0E0',
            borderDark: '#b1b1b1',
          },

          background: {
            default: '#fff',
            paper: '#fff',
            container: '#04679C',
            holder: '#80cbc4',
            vessel: '#fff',
            box: '#04679C',
            contain: '#fff',
            projectItem: 'rgba(247, 247, 247, 1)',
            selectProjects: '#F2F3F4',
            cardTeamMember: 'rgba(255, 255, 255, 0.5)',
            dark: '#ececec',
            ecosystem: ' #F8FAFC',
          },
          text: {
            primary: '#000',
            secondary: '#000000',
            tertiary: '#333333',
            quaternary: '#444444',
            quinary: '#00923D',
            senary: '#4db6ac',
            septenary: '#006F56',
            pay: '#fff',
            octonary: '#333333',
            nonary: '#041370',
            denary: '#000F20',
            service: '#FFFFFF',
            serviceText: '#04679C',
            selectProjects: '#77838F',
            role: '#555555',
            dark: '#333333',
            disabled: 'rgba(0,0,0,0.38)',
            disabledBackground: 'rgba(0,0,0,0.12)',
            projects: '#4A4A4A',
            titleProjects: '#006F56',
            invesment: '#4A4A4A',
            investementDescription: '#555555',
            investementItem: '#77838F',
            investementlocationIcon: '#77838F',
            sumaryHeader: '#555555',
            disclaimerText: '#77838F',
            backButton: '#77838F',
            quantitySelectorSection: '#77838F',
            paymentTitle: '#555555',
            paymentDisabled: '#77838F',
            billingtitle: '#4A4A4A',
            cardTitle: '#77838F',

            cardBadges: '#555555',
            checkboxPayment: '#555555',

            paymentBack: '#555555',
            step: '#77838F',

            // radioCircle:"#555555"
            impactText: '#E8E8E8',
            ecosystemText: '#D8E3FB',
            ecosystemHeader: '#94A3B8',
            ecosysteMetricBox: 'rgba(0, 0, 0, 0.08)',
            ecosysteMetric: '#0F172A',
            ecosysteMetricHover: '#1E40AF',
            ecosysteMetricLabel: '#64748B',
            ecosystemPartnerItem: '#64748B',
            ecosystemPartnerItemHover: '#0F172A',
          },
          button: {
            primary: '#fff',
            secondary: '#40ad6e',
            hover: '#40ad6e',
            border: '#40ad6e',
            text: '#40ad6e',
            pay: '#04679C',
            serviceButton: '#04679C',
            hoverService: '#04679C',
            heroBg: '#0A0E1A',
            heroText: '#FFFFFF',
            heroBorder: '#0A0E1A',
            heroHoverBg: '#1A1F2E',
            heroHoverBorder: '#1A1F2E',
            heroHoverText: '#FFFFFF',
          },
          footer: {
            default: '#2c2c2c',
          },
          opinions: {
            primary: '#333333',
            secondary: '#333333',
          },
          search: {
            icon: '#666666',
            border: '#80B7AB',
            text: '#8C8C8C',
          },
          link: {
            default: '000F20',
          },
          input: {
            primary: '#000',
          },
          hero: {
            badgeBorder: '#06E89F',
            badgeBackground: 'rgba(6, 232, 159, 0.08)',
            badgeShadow: '0px 0px 12px 0px rgba(6, 232, 159, 0.35)',
            badgeText: '#06E89F',
            title: '#0A0E1A',
            subtitle: '#000000',
            cardBorder: '#E0E0E0',
            cardTitle: '#0A0E1A',
            cardText: '#5C6B73',
            cardLabelTarget: '#256DE6',
            ambitionLabel: '#5C6B73',
            ambitionQuote: '#0A0E1A',
          },
        }
      : {
          // palette values for dark mode
          primary: {
            main: '#000',
          },
          secondary: {
            main: '#010C2B',
          },
          tertiary: {
            main: '#FFFFFF',
          },
          quaternary: {
            main: '#40ad6e',
          },
          borderSelect: {
            main: '#77838F',
            border: 'transparent',
            borderFocus: 'transparent',
            borderDark: '#00DD9E',
          },

          background: {
            default: '#041370;',
            // default: '#010C2B',
            paper: '#010C2B',
            container: '#58BDFD',
            holder: '#010C2B',
            vessel: '#58BDFD',
            box: '#0C1839',
            contain: '#1B2747',
            projectItem: '#1B2747',
            selectProjects: '#F2F3F4',
            cardTeamMember: '',
            dark: 'rgba(0, 0, 0, 0.5) ',
            ecosystem: 'transparent',
          },
          text: {
            primary: '#fff',
            secondary: '#fff',
            tertiary: '#fff',
            quaternary: '#fff',
            quinary: '#58BDFD',
            senary: '#58BDFD',
            septenary: '#58BDFD',
            nonary: '#fff',
            pay: '#04679C',
            denary: '#FFFFFF',
            service: '#06E89F',
            projects: '#8892B0',
            titleProjects: '#00F59B',
            serviceText: '#06E89F',
            selectProjects: '#77838F',
            role: '#E8E8E8',
            dark: '#00DD9E',
            disabled: 'rgba(255,255,255,0.5)',
            disabledBackground: 'rgba(255,255,255,0.12)',
            invesment: '#fbf8ff',
            investementDescription: 'rgba(223, 224, 255, 0.8)',
            investementItem: 'rgba(223, 224, 255, 0.7)',
            investementlocationIcon: 'rgba(223, 224, 255, 0.6)',
            sumaryHeader: 'rgba(223, 224, 255, 0.5)',
            disclaimerText: 'rgba(223, 224, 255, 0.4)',
            backButton: 'rgba(223, 224, 255, 0.2)',
            quantitySelectorSection: 'rgba(223, 224, 255, 0.1)',
            paymentTitle: 'rgba(255, 255, 255, 0.6)',
            paymentDisabled: 'rgba(255, 255, 255, 0.6)',
            billingtitle: '#ffffff',
            cardTitle: 'rgba(255, 255, 255, 0.3)',
            cardBadges: 'rgba(255, 255, 255, 0.5)',
            checkboxPayment: 'rgba(255, 255, 255, 0.2)',
            paymentBack: 'rgba(255, 255, 255, 0.4)',
            step: 'rgba(255, 255, 255, 0.1)',
            impactText: 'rgba(255, 255, 255, 0.05)',
            ecosystemText: '#0F172A',
            ecosystemHeader: '#64748B',
            ecosysteMetricBox: 'rgba(255, 255, 255, 0.08)',
            ecosysteMetric: '#FFFFFF',
            ecosysteMetricHover: '#C0C6DE',
            ecosysteMetricLabel: '#64748B',
            ecosystemPartnerItem: '#94A3B8',
            ecosystemPartnerItemHover: '#FFFFFF',

            // radioCircle:"rgba(255, 255, 255, 0.1)"
          },
          button: {
            primary: '#58BDFD',
            secondary: '#010C2B',
            hover: '#daf1f9',
            border: '#58BDFD',
            text: '#58BDFD',
            pay: '#fff',
            serviceButton: '#06E89F',
            heroBg: '#06E89F',
            heroText: '#0A0E1A',
            heroBorder: '#06E89F',
            heroHoverBg: '#05C98D',
            heroHoverBorder: '#05C98D',
            heroHoverText: '#0A0E1A',
          },
          footer: {
            default: '#010615',
          },
          opinions: {
            primary: '#58BDFD',
            secondary: '#afafaf',
          },
          search: {
            icon: '#FFFFFF',
            border: '#58BDFD',
            text: '#FFFFFF',
          },
          link: {
            default: 'FFFFFF',
          },
          input: {
            primary: '#000',
          },
          hero: {
            badgeBorder: '#06E89F',
            badgeBackground: 'rgba(6, 232, 159, 0.08)',
            badgeShadow: '0px 0px 12px 0px rgba(6, 232, 159, 0.35)',
            badgeText: '#06E89F',
            title: '#FFFFFF',
            subtitle: '#FFFFFF',
            cardBorder: '#1D3190',
            cardTitle: '#FFFFFF',
            cardText: '#9AA3B2',
            cardLabelTarget: '#06E89F',
            ambitionLabel: '#9AA3B2',
            ambitionQuote: '#FFFFFF',
          },
        }),
  },
});

export default getDesignTokens;
